/**
 * 생활기록부 맞춤법 검사 한시 공개 기간 (#316, 사용자 결정 2026-11-02).
 * 기간을 바꿀 곳은 이 파일 두 상수뿐이다.
 * 끝 시각은 2027-02-28 하루가 다 지난 시점(3월 1일 0시, 한국 시간)이다.
 */
export const SAENGGIBU_OPEN_AT = '2026-11-03T00:00:00+09:00';
export const SAENGGIBU_CLOSE_AT = '2027-03-01T00:00:00+09:00';

/** 화면에 보이는 기간 문구. 위 상수와 같이 고친다. */
export const SAENGGIBU_PERIOD_LABEL = '2026년 11월 3일부터 2027년 2월 28일까지';

/**
 * 공개 중지 스위치 (사용자 지시 2026-11-05).
 * true 면 기간과 상관없이 메뉴·배너에서 숨기고 /saenggibu 는 '준비 중' 안내만 보인다.
 * 다시 열 때는 이 값을 false 로 바꾸면 된다.
 */
export const SAENGGIBU_SUSPENDED = true;

export type SaenggibuPeriodState = 'before' | 'open' | 'closed' | 'suspended';

export function getSaenggibuPeriodState(
  now: Date = new Date(),
  suspended: boolean = SAENGGIBU_SUSPENDED
): SaenggibuPeriodState {
  if (suspended) return 'suspended';
  const t = now.getTime();
  if (t < Date.parse(SAENGGIBU_OPEN_AT)) return 'before';
  if (t >= Date.parse(SAENGGIBU_CLOSE_AT)) return 'closed';
  return 'open';
}

/** 남은 일수(올림). 열려 있을 때만 의미가 있다. */
export function getSaenggibuDaysLeft(now: Date = new Date()): number {
  const ms = Date.parse(SAENGGIBU_CLOSE_AT) - now.getTime();
  return Math.max(0, Math.ceil(ms / 86_400_000));
}
